import type { CSSProperties } from "react"

const baseButtonStyles: CSSProperties = {
  fontFamily: `Barlow`,
  fontWeight: 595,
  borderRadius: `5px`,
  minWidth: `127px`,
  height: `30px`,
  lineHeight: `17px`,
  textAlign: `center`,
  padding: `2px 10px`,
  alignItems: `center`,
  justifyContent: `center`,
  display: `flex`,
  gap: `10px`,
  textTransform: `capitalize`,
  letterSpacing: `1px`,
  fontSize: `var(--step--2)`,
  boxSizing: `border-box`,
}

export const getSecondaryButtonStyles = (disabled = false): CSSProperties => ({
  ...baseButtonStyles,
  color: disabled ? `var(--blue-faded)` : `var(--blue)`,
  background: `var(--white)`,
  border: `1px solid ${disabled ? `var(--blue-faded)` : `var(--blue)`}`,
  cursor: disabled ? `not-allowed` : `pointer`,
})

export const getPrimaryButtonStyles = (disabled = false): CSSProperties => ({
  ...baseButtonStyles,
  color: `var(--white)`,
  background: disabled ? `var(--blue-faded)` : `var(--banner-blue)`,
  border: `none`,
  cursor: disabled ? `not-allowed` : `pointer`,
})
